import { FC, memo } from 'react'
import { Typography } from '@maas-components/core'
import { InfoOutlined } from '@maas-components/icons'
import { EVariationTypes } from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import { VariationType } from 'core/components/Multivariation'
import { useMultivariationValues } from '../store'
import { FlowCardProps } from '../types'
import { DescriptionCard } from './style'

const FirstVariationType: FC<FlowCardProps> = ({ onNext, custom }) => {
  const { setVariationType, getType, setValues } = useMultivariationValues()
  const currentType = getType('first')

  const handleSubmit = (value: EVariationTypes) => {
    setVariationType('first', value)

    if (!!currentType && value !== currentType) {
      setValues({})
    }

    onNext()
  }

  const description = (
    <DescriptionCard variant="outlined" className="px-3 py-2 d-flex align-center">
      <InfoOutlined color="primary" className="mr-1" />
      <Typography variant="body2" color="textSecondary">
        {custom
          ? i18n.t('multivariation.cardDescriptionNets')
          : i18n.t('multivariation.cardDescription')}
      </Typography>
    </DescriptionCard>
  )

  return custom?.variation ? (
    custom.variation({
      onSubmit: handleSubmit,
      title: i18n.t('multivariation.variationType.firstVariationTitle'),
      description,
      variationTypeSelected: currentType,
    })
  ) : (
    <VariationType
      onSubmit={handleSubmit}
      title={i18n.t('multivariation.variationType.firstVariationTitle')}
      description={description}
      variationTypeSelected={currentType}
    />
  )
}

export default memo(FirstVariationType)
